import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import accountCheck from "@iconify/icons-mdi/account-check";
import { Icon } from "@iconify/react";
import { useMyTimesheetExaminers } from "my-timesheet/hooks";
import { OcCard } from "oc/components";

interface MyTimesheetExaminersCardProps {
  contractCode: string;
}

export const MyTimesheetExaminersCard = ({
  contractCode,
}: MyTimesheetExaminersCardProps) => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();

  const { data, loading, error } = useMyTimesheetExaminers({
    contractCode: contractCode,
    locale: i18n.language,
  });

  if (data?.length === 0 && !loading) {
    return (
      <Box style={{ color: theme.palette.primary.main, padding: "16px 0px" }}>
        {t("OC_MISSING_EXAMINERS")}
      </Box>
    );
  }

  return (
    <OcCard
      label={t("OC_EXAMINERS")}
      height="100%"
      loading={!data && loading}
      error={!!error}
    >
      {data?.map((item: typeof data, index: number) => (
        <Box
          key={`my-time-sheet-examiner-${index}`}
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Icon icon={accountCheck} height="24px" />
          <Box width="10px" />
          <Box paddingBottom="4px">{item}</Box>
        </Box>
      ))}
    </OcCard>
  );
};

export default MyTimesheetExaminersCard;
